import React, { useImperativeHandle } from 'react'
import { Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import { Controller, useForm } from 'react-hook-form'
import SydLabel from '../../../../../commonDesign/SydLabel'
import SydInput from '../../../../../commonDesign/SydInput'

const ParameterInputForm = React.forwardRef(function ParameterInputForm ({ requiredParams }, ref) {
  const defaultValues = (requiredParams || []).reduce((acc, param) => {
    acc[param] = ''
    return acc
  }, {})

  const form = useForm({
    defaultValues,
    mode: 'onChange'
  })

  // Expose method to get current form values imperatively
  useImperativeHandle(ref, () => ({
    getValues: () => form.getValues(),
    isValid: () => form.formState.isValid
  }), [form])

  if (!requiredParams || requiredParams.length === 0) {
    return (
      <div style={{ padding: '16px', backgroundColor: 'var(--bg-color-subtle)', borderRadius: '4px' }}>
        <p>No parameters required for this blueprint</p>
      </div>
    )
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <h4>Required Parameters</h4>
      </Grid>
      {requiredParams.map(param => (
        <Grid item xs={12} md={6} key={param}>
          <Controller
            control={form.control}
            name={param}
            rules={{ required: { value: true, message: 'Required' } }}
            render={(f) => (
              <SydLabel required label={param}>
                <SydInput {...f.field} placeholder={`Enter ${param}`} />
              </SydLabel>
            )}
          />
        </Grid>
      ))}
    </Grid>
  )
})

ParameterInputForm.propTypes = {
  requiredParams: PropTypes.array
}

ParameterInputForm.defaultProps = {
  requiredParams: []
}

export default ParameterInputForm
